<template>
    <div class="campus-events-search">
        <div class="filters">

            <FilterBy
                :label="'Filter by province'"
                :options="provinces"
                @input="onSelectProvince"
            />

            <FilterBy
                :label="'Filter by month'"
                :options="months"
                @input="onSelectMonth"
            />

        </div>
        <div class="sort" role="region" aria-labelledby="sortLabel">
            <div class="sort__label" id="sortLabel">
                <span>Sort</span>
            </div>

            <div class="sort-options">
                <button aria-label="Sort by ascending" :aria-pressed="sort === 'asc'" class="btn sort-option" @click="selectSort('asc')">
                    <span :class="{'sort-icon':true ,'sort-icon--asc':true,  'sort-icon--active': sort === 'asc'}">
                        <span class="bar" v-for="x in 4" :key="x" />
                    </span>
                </button>
                <button aria-label="Sort by descending" :aria-pressed="sort === 'desc'" class="btn sort-option" @click="selectSort('desc')">
                    <span :class="{'sort-icon':true ,'sort-icon--desc':true,  'sort-icon--active': sort === 'desc'}">
                        <span class="bar" v-for="x in 4" :key="x" />
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from 'moment'
import FilterBy from "@/components/Ui/FilterBy";

export default {
    name: "CampusEventsSearch",

    components: {FilterBy},

    data() {
        return {
            province: null,
            month: null,
            sortDirectory: '/static/img/'
        }
    },

    computed: {
        months() {
            let months = [];
            for (let i = 0; i < 12; i++) {
                let items = {
                    id: i,
                    name: moment().month(i).format('MMMM')
                };
                months.push(items)
            }

            return months
        },

        sortAscSrcset() {
            const img = [
                `${this.sortDirectory}/sort-asc.png`,
                `${this.sortDirectory}/sort-asc_x2.png`,
            ]

            return `${img[0]} 1x, ${img[1]} 2x`
        },

        sortDescSrcset() {
            const img = [
                `${this.sortDirectory}/sort-desc.png`,
                `${this.sortDirectory}/sort-desc_x2.png`,
            ]

            return `${img[0]} 1x, ${img[1]} 2x`
        },

        ...mapState({
            provinces: state => state.campus.provinces,
            sort: state => state.campus.sort
        })
    },

    methods: {
        onSelectProvince(provinceId) {
            this.province = provinceId
            this.$store.commit('setCampusEventsFilter', {type: 'province', value: provinceId})
        },

        onSelectMonth(month) {
            this.month = month
            this.$store.commit('setCampusEventsFilter', {type: 'month', value: month})
        },

        selectSort(type) {
            this.$store.commit('setSortType', type)
        }

    }
}
</script>
